import { useEffect, useState } from "react";
import { DataCollectionApi } from "../Api/api.DataCollection";

const useDataCollectionSetlists = () => {
  const [countries, setCountries] = useState<any[]>([]);
  const activitySectors = [
    { es: "Construcción", en: "Construction" },
    { es: "Comercio Internacional", en: "International trade" },
    { es: "Deportista profesional", en: "Professional athlete" },
    { es: "Anticuario", en: "Antique dealer" },
    { es: "Comercio de metales preciosos", en: "Precious metal trade" },
    { es: "Organismos sin ánimo de lucro", en: "Non-profit organizations" },
    { es: "Compra-venta moneda extranjera", en: "Foreign currency trading" },
    { es: "Empresa de Auditoría", en: "Audit firm" },
    { es: "Administraciones Públicas", en: "Public Administrations" },
    { es: "Industria tabaquera", en: "Tobacco Industry" },
    { es: "Automóviles", en: "Automobiles" },
    { es: "Joyería", en: "Jewelry" },
    { es: "Venta al por mayor", en: "Wholesale" },
    {
      es: "Gestión y alquiler de bienes inmuebles",
      en: "Real Estate Management and Rental",
    },
    { es: "Comercio electrónico", en: "E-commerce" },
    { es: "Intermediarios financieros", en: "Financial Intermediaries" },
    { es: "Comercio de arte", en: "Art Trading" },
    { es: "Casinos", en: "Casinos" },
    { es: "Despacho de Abogado", en: "Law Firm" },
    { es: "Notaría", en: "Notary's office" },
	{ es: "Otro - Especificar", en: "Other - Specify" },
  ];

  const lastExcerciseNetWorths = [
    { es: "Hasta 30.000 euros", en: "Up to 30,000 euros" },
    { es: "De 30.000 a 60.000 euros", en: "From 30,000 to 60,000 euros" },
    { es: "De 60.000 a 100.000 euros", en: "From 60,000 to 100,000 euros" },
    { es: "De 100.000 a 300.000 euros", en: "From 100,000 to 300,000 euros" },
    { es: "Más de 300.000", en: "More than 300,000" },
  ];

  const lastExcerciseIncomes = [
    { es: "Sin ingresos anuales", en: "No annual income" },
    ...lastExcerciseNetWorths,
  ];

  const activityOptions = [
    { es: "Cuenta propia", en: "Self-employed" },
    { es: "Cuenta ajena", en: "Employee" },
    { es: "Jubilado", en: "Retired" },
    { es: "Desempleado", en: "Unemployed" },
    { es: "Pensionista", en: "Pensioner" },
    { es: "Estudiante", en: "Student" },
  ];

  const foundsOrigin = [
    {
      es: "Salario",
      en: "Salary",
      documentOptions: [
        { es: "Últimas dos nóminas", en: "Last two payslips" },
        {
          es: "IRPF del titular",
          en: "Income Tax Return of the account holder",
        },
        {
          es: "Certificado de haberes, pensión o subsidio",
          en: "Certificate of earnings, pension or subsidy",
        },
        { es: "Otro", en: "Other" },
      ],
    },
    {
      es: "Actividad empresarial",
      en: "Business activity",
      documentOptions: [
        { es: "Últimas dos nóminas", en: "Last two payslips" },
        {
          es: "IRPF del titular",
          en: "Income Tax Return of the account holder",
        },
        {
          es: "Certificado de haberes, pensión o subsidio",
          en: "Certificate of earnings, pension or subsidy",
        },
      ],
    },
    {
      es: "Venta de bienes",
      en: "Sale of goods",
      documentOptions: [
        {
          es: "Copia de las primeras páginas de la escritura de compraventa de bienes",
          en: "Copy of the first pages of the deed of sale of goods",
        },
        {
          es: "Evidencia de la percepción del ingreso en la cuenta del inversor",
          en: "Evidence of the receipt of income in the investor's account",
        },
      ],
    },
    {
      es: "Indemnización",
      en: "Compensation",
      documentOptions: [
        {
          es: "Justificante de la transferencia o ingreso recibido donde aparezca claro el concepto",
          en: "Proof of the transfer or deposit received where the concept is clearly stated",
        },
      ],
    },
    {
      es: "Donación",
      en: "Donation",
      documentOptions: [
        {
          es: "Copia de las primeras páginas de la escritura de la donación o del testamento",
          en: "Copy of the first pages of the deed of donation or will",
        },
        {
          es: "Pago a la AEAT del impuesto de Sucesiones y Donaciones",
          en: "Payment to the AEAT of the Inheritance and Donations tax",
        },
        {
          es: "Justificante de la transferencia o ingreso recibido donde aparezca claro el concepto",
          en: "Proof of the transfer or deposit received where the concept is clearly stated",
        },
      ],
    },
    {
      es: "Herencia",
      en: "Inheritance",
      documentOptions: [
        {
          es: "Copia de las primeras páginas de la escritura de la donación o del testamento",
          en: "Copy of the first pages of the deed of donation or will",
        },
        {
          es: "Pago a la AEAT del impuesto de Sucesiones y Donaciones",
          en: "Payment to the AEAT of the Inheritance and Donations tax",
        },
        {
          es: "Justificante de la transferencia o ingreso recibido donde aparezca claro el concepto",
          en: "Proof of the transfer or deposit received where the concept is clearly stated",
        },
      ],
    },
    {
      es: "Ahorros",
      en: "Savings",
      documentOptions: [
        {
          es: "Extracto bancario de la cuenta en la que se encuentren depositados los fondos",
          en: "Bank statement of the account where the funds are deposited",
        },
        {
          es: "Certificado bancario donde se indique el valor de los fondos",
          en: "Bank certificate indicating the value of the funds",
        },
        {
          es: "Si los ahorros están invertidos, Cuenta de valores donde se especifiquen nombre y apellidos del titular, IBAN completo y valor de las participaciones en EUR",
          en: "If the savings are invested, Securities Account specifying the name and surname of the holder, full IBAN and value of the shares in EUR",
        },
      ],
    },
  ];

  const communicationTypes = [
    { es: "Contacto principal", en: "Main contact" },
    { es: "Newsletter y reporting", en: "Newsletter and reporting" },
    { es: "Comunicaciones legales", en: "Legal communications" },
    {
      es: "Llamadas de capital y distribuciones",
      en: "Capital calls and distributions",
    },
  ];

  const positions = [
    { es: "Director/Socio", en: "Director/Partner" },
    { es: "Técnico Senior", en: "Senior Technician" },
    { es: "Técnico", en: "Technician" },
    { es: "Administrativo", en: "Administrative" },
  ];

  useEffect(() => {
	getCountries();
  }, []);

  const getCountries = async () => {
    const response = await DataCollectionApi.getCountries();
    setCountries(response);
  };

  return {
    countries,
    activitySectors,
    lastExcerciseIncomes,
    lastExcerciseNetWorths,
    foundsOrigin,
    activityOptions,
    positions,
	communicationTypes
  };
};

export default useDataCollectionSetlists;
